export default (appVersion, version) => {
  return new Promise((resolve, reject) => {
    const isUpdate = versionCompare(version, appVersion)
    const updateType = checkUpdateType(version, appVersion)
    switch (isUpdate) {
      case 0:
        console.log('不更新')
        break
      case 1:
        if (updateType == 'OPEN_ALL_UPDATE') {
          console.log('全量更新')
          resolve({
            code: isUpdate,
            type: updateType,
          })
        } else {
          console.log('增量更新')
          resolve({
            code: isUpdate,
            type: updateType,
          })
        }
        break
    }
  })
}

// 1为当前版本比更新版本低，0为版本一致，-1为当前版本比更新版本高
function versionCompare(stra, strb) {
  const straArr = stra.split('.')
  const strbArr = strb.split('.')
  const maxLen = Math.max(straArr.length, strbArr.length)
  let result
  let sa
  let sb
  for (let i = 0; i < maxLen; i++) {
    sa = ~~straArr[i]
    sb = ~~strbArr[i]
    if (sa > sb) {
      result = 1
    } else if (sa < sb) {
      result = -1
    } else {
      result = 0
    }
    if (result !== 0) {
      return result
    }
  }
  return result
}

// 判断全量更新还是增量更新
function checkUpdateType(remoteVersion, currentVersion) {
  const remoteVersionArr = remoteVersion.split('.')
  const currentVersionArr = currentVersion.split('.')

  if (Number(remoteVersionArr[0]) > Number(currentVersionArr[0])) {
    // 开启全量更新
    return 'OPEN_ALL_UPDATE'
  } else if (
    Number(remoteVersionArr[2]) > Number(currentVersionArr[2]) ||
    Number(remoteVersionArr[1]) > Number(currentVersionArr[1])
  ) {
    // 开启增量更新
    return 'OPEN_PART_UPDATE'
  } else {
    return 'NO_UPDATE'
  }
}
